"use strict";

exports.__esModule = true;
exports["default"] = forwardRef;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function forwardRef(WrappedComponent) {
  function ForwardedRefComponent(props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, Object.assign({
      forwardedRef: ref
    }, props));
  }

  var wrappedComponentName = typeof WrappedComponent === 'string' ? 'Component' : WrappedComponent.displayName || WrappedComponent.name || 'Component';
  ForwardedRefComponent.displayName = wrappedComponentName;
  return /*#__PURE__*/_react["default"].forwardRef(ForwardedRefComponent);
}